// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.178.0
//   protoc               unknown
// source: protos/sms/v1/package_manager_config.proto

/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";
import { EncryptedValueDictMessage } from "../../encryption/v1/encryption";
import { Ecosystem, ecosystemFromJSON, ecosystemToJSON, ecosystemToNumber } from "../../sca/v1/sca";

export const protobufPackage = "protos.sms.v1";

export interface GetPackageManagerAuthConfigsRequest {
  deploymentId: number;
}

export interface GetPackageManagerAuthConfigsResponse {
  deploymentId: number;
  configs: PackageManagerConfigs | undefined;
}

export interface PostPackageManagerAuthCredentialsRequest {
  deploymentId: number;
  packageManagerCredentials: PackageManagerCredentials[];
}

export interface PostPackageManagerAuthCredentialsResponse {
}

export interface UpdatePackageManagerAuthCredentialsRequest {
  deploymentId: number;
  packageManagerConfigId: number;
  packageManagerCredentials: PackageManagerCredentials | undefined;
}

export interface UpdatePackageManagerAuthCredentialsResponse {
  deploymentId: number;
  packageManagerConfigId: number;
  url: string;
  ecosystem: Ecosystem;
}

export interface DeletePackageManagerAuthConfigsRequest {
  packageManagerConfigId: number;
}

export interface DeletePackageManagerAuthConfigsResponse {
  packageManagerConfigId: number;
}

export interface MavenCredentials {
  username: string;
  password: string;
}

export interface MavenConfig {
  url: string;
  encryptedMavenCredentials: EncryptedValueDictMessage | undefined;
}

export interface PypiCredentials {
  username: string;
  password: string;
}

export interface PypiConfig {
  url: string;
  encryptedPypiCredentials: EncryptedValueDictMessage | undefined;
}

export interface PackageManagerConfig {
  config?: { $case: "maven"; maven: MavenConfig } | { $case: "pypi"; pypi: PypiConfig } | undefined;
  requiresAuth: boolean;
}

export interface PackageManagerConfigs {
  packageManagerConfigs: PackageManagerConfig[];
}

export interface PackageManagerCredentials {
  url: string;
  requiresAuth: boolean;
  ecosystem: Ecosystem;
  credentials?: { $case: "maven"; maven: MavenCredentials } | { $case: "pypi"; pypi: PypiCredentials } | undefined;
}

function createBaseGetPackageManagerAuthConfigsRequest(): GetPackageManagerAuthConfigsRequest {
  return { deploymentId: 0 };
}

export const GetPackageManagerAuthConfigsRequest = {
  encode(message: GetPackageManagerAuthConfigsRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.deploymentId !== 0) {
      writer.uint32(8).uint64(message.deploymentId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetPackageManagerAuthConfigsRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetPackageManagerAuthConfigsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.deploymentId = longToNumber(reader.uint64() as Long);
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetPackageManagerAuthConfigsRequest {
    return { deploymentId: isSet(object.deploymentId) ? globalThis.Number(object.deploymentId) : 0 };
  },

  toJSON(message: GetPackageManagerAuthConfigsRequest): unknown {
    const obj: any = {};
    if (message.deploymentId !== 0) {
      obj.deploymentId = Math.round(message.deploymentId);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetPackageManagerAuthConfigsRequest>, I>>(
    base?: I,
  ): GetPackageManagerAuthConfigsRequest {
    return GetPackageManagerAuthConfigsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetPackageManagerAuthConfigsRequest>, I>>(
    object: I,
  ): GetPackageManagerAuthConfigsRequest {
    const message = createBaseGetPackageManagerAuthConfigsRequest();
    message.deploymentId = object.deploymentId ?? 0;
    return message;
  },
};

function createBaseGetPackageManagerAuthConfigsResponse(): GetPackageManagerAuthConfigsResponse {
  return { deploymentId: 0, configs: undefined };
}

export const GetPackageManagerAuthConfigsResponse = {
  encode(message: GetPackageManagerAuthConfigsResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.deploymentId !== 0) {
      writer.uint32(8).uint64(message.deploymentId);
    }
    if (message.configs !== undefined) {
      PackageManagerConfigs.encode(message.configs, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetPackageManagerAuthConfigsResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetPackageManagerAuthConfigsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.deploymentId = longToNumber(reader.uint64() as Long);
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.configs = PackageManagerConfigs.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetPackageManagerAuthConfigsResponse {
    return {
      deploymentId: isSet(object.deploymentId) ? globalThis.Number(object.deploymentId) : 0,
      configs: isSet(object.configs) ? PackageManagerConfigs.fromJSON(object.configs) : undefined,
    };
  },

  toJSON(message: GetPackageManagerAuthConfigsResponse): unknown {
    const obj: any = {};
    if (message.deploymentId !== 0) {
      obj.deploymentId = Math.round(message.deploymentId);
    }
    if (message.configs !== undefined) {
      obj.configs = PackageManagerConfigs.toJSON(message.configs);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetPackageManagerAuthConfigsResponse>, I>>(
    base?: I,
  ): GetPackageManagerAuthConfigsResponse {
    return GetPackageManagerAuthConfigsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetPackageManagerAuthConfigsResponse>, I>>(
    object: I,
  ): GetPackageManagerAuthConfigsResponse {
    const message = createBaseGetPackageManagerAuthConfigsResponse();
    message.deploymentId = object.deploymentId ?? 0;
    message.configs = (object.configs !== undefined && object.configs !== null)
      ? PackageManagerConfigs.fromPartial(object.configs)
      : undefined;
    return message;
  },
};

function createBasePostPackageManagerAuthCredentialsRequest(): PostPackageManagerAuthCredentialsRequest {
  return { deploymentId: 0, packageManagerCredentials: [] };
}

export const PostPackageManagerAuthCredentialsRequest = {
  encode(message: PostPackageManagerAuthCredentialsRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.deploymentId !== 0) {
      writer.uint32(8).uint64(message.deploymentId);
    }
    for (const v of message.packageManagerCredentials) {
      PackageManagerCredentials.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PostPackageManagerAuthCredentialsRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePostPackageManagerAuthCredentialsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.deploymentId = longToNumber(reader.uint64() as Long);
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.packageManagerCredentials.push(PackageManagerCredentials.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PostPackageManagerAuthCredentialsRequest {
    return {
      deploymentId: isSet(object.deploymentId) ? globalThis.Number(object.deploymentId) : 0,
      packageManagerCredentials: globalThis.Array.isArray(object?.packageManagerCredentials)
        ? object.packageManagerCredentials.map((e: any) => PackageManagerCredentials.fromJSON(e))
        : [],
    };
  },

  toJSON(message: PostPackageManagerAuthCredentialsRequest): unknown {
    const obj: any = {};
    if (message.deploymentId !== 0) {
      obj.deploymentId = Math.round(message.deploymentId);
    }
    if (message.packageManagerCredentials?.length) {
      obj.packageManagerCredentials = message.packageManagerCredentials.map((e) => PackageManagerCredentials.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PostPackageManagerAuthCredentialsRequest>, I>>(
    base?: I,
  ): PostPackageManagerAuthCredentialsRequest {
    return PostPackageManagerAuthCredentialsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PostPackageManagerAuthCredentialsRequest>, I>>(
    object: I,
  ): PostPackageManagerAuthCredentialsRequest {
    const message = createBasePostPackageManagerAuthCredentialsRequest();
    message.deploymentId = object.deploymentId ?? 0;
    message.packageManagerCredentials =
      object.packageManagerCredentials?.map((e) => PackageManagerCredentials.fromPartial(e)) || [];
    return message;
  },
};

function createBasePostPackageManagerAuthCredentialsResponse(): PostPackageManagerAuthCredentialsResponse {
  return {};
}

export const PostPackageManagerAuthCredentialsResponse = {
  encode(_: PostPackageManagerAuthCredentialsResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PostPackageManagerAuthCredentialsResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePostPackageManagerAuthCredentialsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): PostPackageManagerAuthCredentialsResponse {
    return {};
  },

  toJSON(_: PostPackageManagerAuthCredentialsResponse): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<PostPackageManagerAuthCredentialsResponse>, I>>(
    base?: I,
  ): PostPackageManagerAuthCredentialsResponse {
    return PostPackageManagerAuthCredentialsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PostPackageManagerAuthCredentialsResponse>, I>>(
    _: I,
  ): PostPackageManagerAuthCredentialsResponse {
    const message = createBasePostPackageManagerAuthCredentialsResponse();
    return message;
  },
};

function createBaseUpdatePackageManagerAuthCredentialsRequest(): UpdatePackageManagerAuthCredentialsRequest {
  return { deploymentId: 0, packageManagerConfigId: 0, packageManagerCredentials: undefined };
}

export const UpdatePackageManagerAuthCredentialsRequest = {
  encode(message: UpdatePackageManagerAuthCredentialsRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.deploymentId !== 0) {
      writer.uint32(8).uint64(message.deploymentId);
    }
    if (message.packageManagerConfigId !== 0) {
      writer.uint32(16).uint64(message.packageManagerConfigId);
    }
    if (message.packageManagerCredentials !== undefined) {
      PackageManagerCredentials.encode(message.packageManagerCredentials, writer.uint32(26).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UpdatePackageManagerAuthCredentialsRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdatePackageManagerAuthCredentialsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.deploymentId = longToNumber(reader.uint64() as Long);
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.packageManagerConfigId = longToNumber(reader.uint64() as Long);
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.packageManagerCredentials = PackageManagerCredentials.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdatePackageManagerAuthCredentialsRequest {
    return {
      deploymentId: isSet(object.deploymentId) ? globalThis.Number(object.deploymentId) : 0,
      packageManagerConfigId: isSet(object.packageManagerConfigId)
        ? globalThis.Number(object.packageManagerConfigId)
        : 0,
      packageManagerCredentials: isSet(object.packageManagerCredentials)
        ? PackageManagerCredentials.fromJSON(object.packageManagerCredentials)
        : undefined,
    };
  },

  toJSON(message: UpdatePackageManagerAuthCredentialsRequest): unknown {
    const obj: any = {};
    if (message.deploymentId !== 0) {
      obj.deploymentId = Math.round(message.deploymentId);
    }
    if (message.packageManagerConfigId !== 0) {
      obj.packageManagerConfigId = Math.round(message.packageManagerConfigId);
    }
    if (message.packageManagerCredentials !== undefined) {
      obj.packageManagerCredentials = PackageManagerCredentials.toJSON(message.packageManagerCredentials);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdatePackageManagerAuthCredentialsRequest>, I>>(
    base?: I,
  ): UpdatePackageManagerAuthCredentialsRequest {
    return UpdatePackageManagerAuthCredentialsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdatePackageManagerAuthCredentialsRequest>, I>>(
    object: I,
  ): UpdatePackageManagerAuthCredentialsRequest {
    const message = createBaseUpdatePackageManagerAuthCredentialsRequest();
    message.deploymentId = object.deploymentId ?? 0;
    message.packageManagerConfigId = object.packageManagerConfigId ?? 0;
    message.packageManagerCredentials =
      (object.packageManagerCredentials !== undefined && object.packageManagerCredentials !== null)
        ? PackageManagerCredentials.fromPartial(object.packageManagerCredentials)
        : undefined;
    return message;
  },
};

function createBaseUpdatePackageManagerAuthCredentialsResponse(): UpdatePackageManagerAuthCredentialsResponse {
  return { deploymentId: 0, packageManagerConfigId: 0, url: "", ecosystem: Ecosystem.no_package_manager };
}

export const UpdatePackageManagerAuthCredentialsResponse = {
  encode(message: UpdatePackageManagerAuthCredentialsResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.deploymentId !== 0) {
      writer.uint32(8).uint64(message.deploymentId);
    }
    if (message.packageManagerConfigId !== 0) {
      writer.uint32(16).uint64(message.packageManagerConfigId);
    }
    if (message.url !== "") {
      writer.uint32(26).string(message.url);
    }
    if (message.ecosystem !== Ecosystem.no_package_manager) {
      writer.uint32(32).int32(ecosystemToNumber(message.ecosystem));
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UpdatePackageManagerAuthCredentialsResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdatePackageManagerAuthCredentialsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.deploymentId = longToNumber(reader.uint64() as Long);
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.packageManagerConfigId = longToNumber(reader.uint64() as Long);
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.url = reader.string();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.ecosystem = ecosystemFromJSON(reader.int32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdatePackageManagerAuthCredentialsResponse {
    return {
      deploymentId: isSet(object.deploymentId) ? globalThis.Number(object.deploymentId) : 0,
      packageManagerConfigId: isSet(object.packageManagerConfigId)
        ? globalThis.Number(object.packageManagerConfigId)
        : 0,
      url: isSet(object.url) ? globalThis.String(object.url) : "",
      ecosystem: isSet(object.ecosystem) ? ecosystemFromJSON(object.ecosystem) : Ecosystem.no_package_manager,
    };
  },

  toJSON(message: UpdatePackageManagerAuthCredentialsResponse): unknown {
    const obj: any = {};
    if (message.deploymentId !== 0) {
      obj.deploymentId = Math.round(message.deploymentId);
    }
    if (message.packageManagerConfigId !== 0) {
      obj.packageManagerConfigId = Math.round(message.packageManagerConfigId);
    }
    if (message.url !== "") {
      obj.url = message.url;
    }
    if (message.ecosystem !== Ecosystem.no_package_manager) {
      obj.ecosystem = ecosystemToJSON(message.ecosystem);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdatePackageManagerAuthCredentialsResponse>, I>>(
    base?: I,
  ): UpdatePackageManagerAuthCredentialsResponse {
    return UpdatePackageManagerAuthCredentialsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdatePackageManagerAuthCredentialsResponse>, I>>(
    object: I,
  ): UpdatePackageManagerAuthCredentialsResponse {
    const message = createBaseUpdatePackageManagerAuthCredentialsResponse();
    message.deploymentId = object.deploymentId ?? 0;
    message.packageManagerConfigId = object.packageManagerConfigId ?? 0;
    message.url = object.url ?? "";
    message.ecosystem = object.ecosystem ?? Ecosystem.no_package_manager;
    return message;
  },
};

function createBaseDeletePackageManagerAuthConfigsRequest(): DeletePackageManagerAuthConfigsRequest {
  return { packageManagerConfigId: 0 };
}

export const DeletePackageManagerAuthConfigsRequest = {
  encode(message: DeletePackageManagerAuthConfigsRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.packageManagerConfigId !== 0) {
      writer.uint32(8).uint64(message.packageManagerConfigId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): DeletePackageManagerAuthConfigsRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeletePackageManagerAuthConfigsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.packageManagerConfigId = longToNumber(reader.uint64() as Long);
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeletePackageManagerAuthConfigsRequest {
    return {
      packageManagerConfigId: isSet(object.packageManagerConfigId)
        ? globalThis.Number(object.packageManagerConfigId)
        : 0,
    };
  },

  toJSON(message: DeletePackageManagerAuthConfigsRequest): unknown {
    const obj: any = {};
    if (message.packageManagerConfigId !== 0) {
      obj.packageManagerConfigId = Math.round(message.packageManagerConfigId);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeletePackageManagerAuthConfigsRequest>, I>>(
    base?: I,
  ): DeletePackageManagerAuthConfigsRequest {
    return DeletePackageManagerAuthConfigsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeletePackageManagerAuthConfigsRequest>, I>>(
    object: I,
  ): DeletePackageManagerAuthConfigsRequest {
    const message = createBaseDeletePackageManagerAuthConfigsRequest();
    message.packageManagerConfigId = object.packageManagerConfigId ?? 0;
    return message;
  },
};

function createBaseDeletePackageManagerAuthConfigsResponse(): DeletePackageManagerAuthConfigsResponse {
  return { packageManagerConfigId: 0 };
}

export const DeletePackageManagerAuthConfigsResponse = {
  encode(message: DeletePackageManagerAuthConfigsResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.packageManagerConfigId !== 0) {
      writer.uint32(8).uint64(message.packageManagerConfigId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): DeletePackageManagerAuthConfigsResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeletePackageManagerAuthConfigsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.packageManagerConfigId = longToNumber(reader.uint64() as Long);
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeletePackageManagerAuthConfigsResponse {
    return {
      packageManagerConfigId: isSet(object.packageManagerConfigId)
        ? globalThis.Number(object.packageManagerConfigId)
        : 0,
    };
  },

  toJSON(message: DeletePackageManagerAuthConfigsResponse): unknown {
    const obj: any = {};
    if (message.packageManagerConfigId !== 0) {
      obj.packageManagerConfigId = Math.round(message.packageManagerConfigId);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeletePackageManagerAuthConfigsResponse>, I>>(
    base?: I,
  ): DeletePackageManagerAuthConfigsResponse {
    return DeletePackageManagerAuthConfigsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeletePackageManagerAuthConfigsResponse>, I>>(
    object: I,
  ): DeletePackageManagerAuthConfigsResponse {
    const message = createBaseDeletePackageManagerAuthConfigsResponse();
    message.packageManagerConfigId = object.packageManagerConfigId ?? 0;
    return message;
  },
};

function createBaseMavenCredentials(): MavenCredentials {
  return { username: "", password: "" };
}

export const MavenCredentials = {
  encode(message: MavenCredentials, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.username !== "") {
      writer.uint32(10).string(message.username);
    }
    if (message.password !== "") {
      writer.uint32(18).string(message.password);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): MavenCredentials {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMavenCredentials();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.username = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.password = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MavenCredentials {
    return {
      username: isSet(object.username) ? globalThis.String(object.username) : "",
      password: isSet(object.password) ? globalThis.String(object.password) : "",
    };
  },

  toJSON(message: MavenCredentials): unknown {
    const obj: any = {};
    if (message.username !== "") {
      obj.username = message.username;
    }
    if (message.password !== "") {
      obj.password = message.password;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MavenCredentials>, I>>(base?: I): MavenCredentials {
    return MavenCredentials.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MavenCredentials>, I>>(object: I): MavenCredentials {
    const message = createBaseMavenCredentials();
    message.username = object.username ?? "";
    message.password = object.password ?? "";
    return message;
  },
};

function createBaseMavenConfig(): MavenConfig {
  return { url: "", encryptedMavenCredentials: undefined };
}

export const MavenConfig = {
  encode(message: MavenConfig, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.url !== "") {
      writer.uint32(10).string(message.url);
    }
    if (message.encryptedMavenCredentials !== undefined) {
      EncryptedValueDictMessage.encode(message.encryptedMavenCredentials, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): MavenConfig {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMavenConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.url = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.encryptedMavenCredentials = EncryptedValueDictMessage.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MavenConfig {
    return {
      url: isSet(object.url) ? globalThis.String(object.url) : "",
      encryptedMavenCredentials: isSet(object.encryptedMavenCredentials)
        ? EncryptedValueDictMessage.fromJSON(object.encryptedMavenCredentials)
        : undefined,
    };
  },

  toJSON(message: MavenConfig): unknown {
    const obj: any = {};
    if (message.url !== "") {
      obj.url = message.url;
    }
    if (message.encryptedMavenCredentials !== undefined) {
      obj.encryptedMavenCredentials = EncryptedValueDictMessage.toJSON(message.encryptedMavenCredentials);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MavenConfig>, I>>(base?: I): MavenConfig {
    return MavenConfig.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MavenConfig>, I>>(object: I): MavenConfig {
    const message = createBaseMavenConfig();
    message.url = object.url ?? "";
    message.encryptedMavenCredentials =
      (object.encryptedMavenCredentials !== undefined && object.encryptedMavenCredentials !== null)
        ? EncryptedValueDictMessage.fromPartial(object.encryptedMavenCredentials)
        : undefined;
    return message;
  },
};

function createBasePypiCredentials(): PypiCredentials {
  return { username: "", password: "" };
}

export const PypiCredentials = {
  encode(message: PypiCredentials, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.username !== "") {
      writer.uint32(10).string(message.username);
    }
    if (message.password !== "") {
      writer.uint32(18).string(message.password);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PypiCredentials {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePypiCredentials();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.username = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.password = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PypiCredentials {
    return {
      username: isSet(object.username) ? globalThis.String(object.username) : "",
      password: isSet(object.password) ? globalThis.String(object.password) : "",
    };
  },

  toJSON(message: PypiCredentials): unknown {
    const obj: any = {};
    if (message.username !== "") {
      obj.username = message.username;
    }
    if (message.password !== "") {
      obj.password = message.password;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PypiCredentials>, I>>(base?: I): PypiCredentials {
    return PypiCredentials.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PypiCredentials>, I>>(object: I): PypiCredentials {
    const message = createBasePypiCredentials();
    message.username = object.username ?? "";
    message.password = object.password ?? "";
    return message;
  },
};

function createBasePypiConfig(): PypiConfig {
  return { url: "", encryptedPypiCredentials: undefined };
}

export const PypiConfig = {
  encode(message: PypiConfig, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.url !== "") {
      writer.uint32(10).string(message.url);
    }
    if (message.encryptedPypiCredentials !== undefined) {
      EncryptedValueDictMessage.encode(message.encryptedPypiCredentials, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PypiConfig {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePypiConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.url = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.encryptedPypiCredentials = EncryptedValueDictMessage.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PypiConfig {
    return {
      url: isSet(object.url) ? globalThis.String(object.url) : "",
      encryptedPypiCredentials: isSet(object.encryptedPypiCredentials)
        ? EncryptedValueDictMessage.fromJSON(object.encryptedPypiCredentials)
        : undefined,
    };
  },

  toJSON(message: PypiConfig): unknown {
    const obj: any = {};
    if (message.url !== "") {
      obj.url = message.url;
    }
    if (message.encryptedPypiCredentials !== undefined) {
      obj.encryptedPypiCredentials = EncryptedValueDictMessage.toJSON(message.encryptedPypiCredentials);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PypiConfig>, I>>(base?: I): PypiConfig {
    return PypiConfig.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PypiConfig>, I>>(object: I): PypiConfig {
    const message = createBasePypiConfig();
    message.url = object.url ?? "";
    message.encryptedPypiCredentials =
      (object.encryptedPypiCredentials !== undefined && object.encryptedPypiCredentials !== null)
        ? EncryptedValueDictMessage.fromPartial(object.encryptedPypiCredentials)
        : undefined;
    return message;
  },
};

function createBasePackageManagerConfig(): PackageManagerConfig {
  return { config: undefined, requiresAuth: false };
}

export const PackageManagerConfig = {
  encode(message: PackageManagerConfig, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    switch (message.config?.$case) {
      case "maven":
        MavenConfig.encode(message.config.maven, writer.uint32(10).fork()).ldelim();
        break;
      case "pypi":
        PypiConfig.encode(message.config.pypi, writer.uint32(18).fork()).ldelim();
        break;
    }
    if (message.requiresAuth !== false) {
      writer.uint32(24).bool(message.requiresAuth);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PackageManagerConfig {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePackageManagerConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.config = { $case: "maven", maven: MavenConfig.decode(reader, reader.uint32()) };
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.config = { $case: "pypi", pypi: PypiConfig.decode(reader, reader.uint32()) };
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.requiresAuth = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PackageManagerConfig {
    return {
      config: isSet(object.maven)
        ? { $case: "maven", maven: MavenConfig.fromJSON(object.maven) }
        : isSet(object.pypi)
        ? { $case: "pypi", pypi: PypiConfig.fromJSON(object.pypi) }
        : undefined,
      requiresAuth: isSet(object.requiresAuth) ? globalThis.Boolean(object.requiresAuth) : false,
    };
  },

  toJSON(message: PackageManagerConfig): unknown {
    const obj: any = {};
    if (message.config?.$case === "maven") {
      obj.maven = MavenConfig.toJSON(message.config.maven);
    }
    if (message.config?.$case === "pypi") {
      obj.pypi = PypiConfig.toJSON(message.config.pypi);
    }
    if (message.requiresAuth !== false) {
      obj.requiresAuth = message.requiresAuth;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PackageManagerConfig>, I>>(base?: I): PackageManagerConfig {
    return PackageManagerConfig.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PackageManagerConfig>, I>>(object: I): PackageManagerConfig {
    const message = createBasePackageManagerConfig();
    if (object.config?.$case === "maven" && object.config?.maven !== undefined && object.config?.maven !== null) {
      message.config = { $case: "maven", maven: MavenConfig.fromPartial(object.config.maven) };
    }
    if (object.config?.$case === "pypi" && object.config?.pypi !== undefined && object.config?.pypi !== null) {
      message.config = { $case: "pypi", pypi: PypiConfig.fromPartial(object.config.pypi) };
    }
    message.requiresAuth = object.requiresAuth ?? false;
    return message;
  },
};

function createBasePackageManagerConfigs(): PackageManagerConfigs {
  return { packageManagerConfigs: [] };
}

export const PackageManagerConfigs = {
  encode(message: PackageManagerConfigs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.packageManagerConfigs) {
      PackageManagerConfig.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PackageManagerConfigs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePackageManagerConfigs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.packageManagerConfigs.push(PackageManagerConfig.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PackageManagerConfigs {
    return {
      packageManagerConfigs: globalThis.Array.isArray(object?.packageManagerConfigs)
        ? object.packageManagerConfigs.map((e: any) => PackageManagerConfig.fromJSON(e))
        : [],
    };
  },

  toJSON(message: PackageManagerConfigs): unknown {
    const obj: any = {};
    if (message.packageManagerConfigs?.length) {
      obj.packageManagerConfigs = message.packageManagerConfigs.map((e) => PackageManagerConfig.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PackageManagerConfigs>, I>>(base?: I): PackageManagerConfigs {
    return PackageManagerConfigs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PackageManagerConfigs>, I>>(object: I): PackageManagerConfigs {
    const message = createBasePackageManagerConfigs();
    message.packageManagerConfigs = object.packageManagerConfigs?.map((e) => PackageManagerConfig.fromPartial(e)) || [];
    return message;
  },
};

function createBasePackageManagerCredentials(): PackageManagerCredentials {
  return { url: "", requiresAuth: false, ecosystem: Ecosystem.no_package_manager, credentials: undefined };
}

export const PackageManagerCredentials = {
  encode(message: PackageManagerCredentials, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.url !== "") {
      writer.uint32(10).string(message.url);
    }
    if (message.requiresAuth !== false) {
      writer.uint32(16).bool(message.requiresAuth);
    }
    if (message.ecosystem !== Ecosystem.no_package_manager) {
      writer.uint32(24).int32(ecosystemToNumber(message.ecosystem));
    }
    switch (message.credentials?.$case) {
      case "maven":
        MavenCredentials.encode(message.credentials.maven, writer.uint32(34).fork()).ldelim();
        break;
      case "pypi":
        PypiCredentials.encode(message.credentials.pypi, writer.uint32(42).fork()).ldelim();
        break;
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PackageManagerCredentials {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePackageManagerCredentials();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.url = reader.string();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.requiresAuth = reader.bool();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.ecosystem = ecosystemFromJSON(reader.int32());
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.credentials = { $case: "maven", maven: MavenCredentials.decode(reader, reader.uint32()) };
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.credentials = { $case: "pypi", pypi: PypiCredentials.decode(reader, reader.uint32()) };
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PackageManagerCredentials {
    return {
      url: isSet(object.url) ? globalThis.String(object.url) : "",
      requiresAuth: isSet(object.requiresAuth) ? globalThis.Boolean(object.requiresAuth) : false,
      ecosystem: isSet(object.ecosystem) ? ecosystemFromJSON(object.ecosystem) : Ecosystem.no_package_manager,
      credentials: isSet(object.maven)
        ? { $case: "maven", maven: MavenCredentials.fromJSON(object.maven) }
        : isSet(object.pypi)
        ? { $case: "pypi", pypi: PypiCredentials.fromJSON(object.pypi) }
        : undefined,
    };
  },

  toJSON(message: PackageManagerCredentials): unknown {
    const obj: any = {};
    if (message.url !== "") {
      obj.url = message.url;
    }
    if (message.requiresAuth !== false) {
      obj.requiresAuth = message.requiresAuth;
    }
    if (message.ecosystem !== Ecosystem.no_package_manager) {
      obj.ecosystem = ecosystemToJSON(message.ecosystem);
    }
    if (message.credentials?.$case === "maven") {
      obj.maven = MavenCredentials.toJSON(message.credentials.maven);
    }
    if (message.credentials?.$case === "pypi") {
      obj.pypi = PypiCredentials.toJSON(message.credentials.pypi);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PackageManagerCredentials>, I>>(base?: I): PackageManagerCredentials {
    return PackageManagerCredentials.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PackageManagerCredentials>, I>>(object: I): PackageManagerCredentials {
    const message = createBasePackageManagerCredentials();
    message.url = object.url ?? "";
    message.requiresAuth = object.requiresAuth ?? false;
    message.ecosystem = object.ecosystem ?? Ecosystem.no_package_manager;
    if (
      object.credentials?.$case === "maven" &&
      object.credentials?.maven !== undefined &&
      object.credentials?.maven !== null
    ) {
      message.credentials = { $case: "maven", maven: MavenCredentials.fromPartial(object.credentials.maven) };
    }
    if (
      object.credentials?.$case === "pypi" &&
      object.credentials?.pypi !== undefined &&
      object.credentials?.pypi !== null
    ) {
      message.credentials = { $case: "pypi", pypi: PypiCredentials.fromPartial(object.credentials.pypi) };
    }
    return message;
  },
};

export interface SmsPackageManagerConfigService {
  postPackageManagerAuthCredentials(
    request: PostPackageManagerAuthCredentialsRequest,
  ): Promise<PostPackageManagerAuthCredentialsResponse>;
  getPackageManagerAuthConfigs(
    request: GetPackageManagerAuthConfigsRequest,
  ): Promise<GetPackageManagerAuthConfigsResponse>;
  updatePackageManagerAuthCredentials(
    request: UpdatePackageManagerAuthCredentialsRequest,
  ): Promise<UpdatePackageManagerAuthCredentialsResponse>;
  deletePackageManagerAuthConfigs(
    request: DeletePackageManagerAuthConfigsRequest,
  ): Promise<DeletePackageManagerAuthConfigsResponse>;
}

export const SmsPackageManagerConfigServiceServiceName = "protos.sms.v1.SmsPackageManagerConfigService";
export class SmsPackageManagerConfigServiceClientImpl implements SmsPackageManagerConfigService {
  private readonly rpc: Rpc;
  private readonly service: string;
  constructor(rpc: Rpc, opts?: { service?: string }) {
    this.service = opts?.service || SmsPackageManagerConfigServiceServiceName;
    this.rpc = rpc;
    this.postPackageManagerAuthCredentials = this.postPackageManagerAuthCredentials.bind(this);
    this.getPackageManagerAuthConfigs = this.getPackageManagerAuthConfigs.bind(this);
    this.updatePackageManagerAuthCredentials = this.updatePackageManagerAuthCredentials.bind(this);
    this.deletePackageManagerAuthConfigs = this.deletePackageManagerAuthConfigs.bind(this);
  }
  postPackageManagerAuthCredentials(
    request: PostPackageManagerAuthCredentialsRequest,
  ): Promise<PostPackageManagerAuthCredentialsResponse> {
    const data = PostPackageManagerAuthCredentialsRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "PostPackageManagerAuthCredentials", data);
    return promise.then((data) => PostPackageManagerAuthCredentialsResponse.decode(_m0.Reader.create(data)));
  }

  getPackageManagerAuthConfigs(
    request: GetPackageManagerAuthConfigsRequest,
  ): Promise<GetPackageManagerAuthConfigsResponse> {
    const data = GetPackageManagerAuthConfigsRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "GetPackageManagerAuthConfigs", data);
    return promise.then((data) => GetPackageManagerAuthConfigsResponse.decode(_m0.Reader.create(data)));
  }

  updatePackageManagerAuthCredentials(
    request: UpdatePackageManagerAuthCredentialsRequest,
  ): Promise<UpdatePackageManagerAuthCredentialsResponse> {
    const data = UpdatePackageManagerAuthCredentialsRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "UpdatePackageManagerAuthCredentials", data);
    return promise.then((data) => UpdatePackageManagerAuthCredentialsResponse.decode(_m0.Reader.create(data)));
  }

  deletePackageManagerAuthConfigs(
    request: DeletePackageManagerAuthConfigsRequest,
  ): Promise<DeletePackageManagerAuthConfigsResponse> {
    const data = DeletePackageManagerAuthConfigsRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "DeletePackageManagerAuthConfigs", data);
    return promise.then((data) => DeletePackageManagerAuthConfigsResponse.decode(_m0.Reader.create(data)));
  }
}

interface Rpc {
  request(service: string, method: string, data: Uint8Array): Promise<Uint8Array>;
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string } ? { [K in keyof Omit<T, "$case">]?: DeepPartial<T[K]> } & { $case: T["$case"] }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (long.lt(globalThis.Number.MIN_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
